/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";

// Validation Rules
const requiredText = "Required";
const required = value => !value && requiredText;

export const renderField = ({
  showOuterDiv = true,
  input,
  type,
  style,
  children,
  meta: { touched, error, warning },
}) => {
  const component = (
    <Fragment>
      <input {...input} type={type} style={style} />
      {children}
      <br />
      {touched &&
        ((error && <div className="field__error">{error}</div>) ||
          (warning && <div className="field__error">{warning}</div>))}
    </Fragment>
  );
  if (showOuterDiv) {
    return <div>{component}</div>;
  }
  return component;
};

const RadioButton = props => {
  let fieldValidation = [];

  const femaleOnlyQuestions = [
    "PapSmear",
    "Gynaecological",
    "MenstruationDisorder",
    "BreastCancer",
    "Pregnant",
  ];

  if (props.column === "Emp" && !femaleOnlyQuestions.includes(props.questionId)) {
    fieldValidation = [required];
  }

  const renderCol = (
    <td className="highlighted">
      <Field
        name={props.column + props.questionId}
        type="radio"
        component={renderField}
        value={props.value}
        validate={fieldValidation}
      />
    </td>
  );

  return renderCol;
};

RadioButton.propTypes = {
  value: PropTypes.string.isRequired,
  optionsIndex: PropTypes.number.isRequired,
  optionsLength: PropTypes.number.isRequired,
  column: PropTypes.string.isRequired,
  questionId: PropTypes.string.isRequired,
  style: PropTypes.object,
  validate: PropTypes.array,
};

export const RadioButtonGroupRow = props => {
  const style = { ...props.style };

  const elements = [];
  let key = 0;

  elements.push(
    <td style={style} key={key}>
      {props.questionNumber ? props.questionNumber : ""}
    </td>
  );
  key += 1;

  if (props.questionInput) {
    elements.push(
      <td style={style} key={key}>
        <div dangerouslySetInnerHTML={{ __html: props.questionDesc }} />
        <input
          {...props.questionInput}
          id={props.questionInput.id ? props.questionInput.id : props.questionInput.name}
        />
      </td>
    );
  } else {
    elements.push(
      <td style={style} key={key}>
        <div dangerouslySetInnerHTML={{ __html: props.questionDesc }} />
      </td>
    );
  }
  key += 1;

  for (let col = 0; col < props.columns.length; col++) {
    for (let opt = 0; opt < props.options.length; opt++) {
      elements.push(
        <RadioButton
          key={key}
          value={props.options[opt]}
          optionsIndex={opt}
          optionsLength={props.options.length}
          column={props.columns[col]}
          questionId={props.questionId}
          style={props.style}
          validate={[props.validate]}
        />
      );
      key += 1;

      if (opt === props.options.length - 1) {
        elements.push(<td className="break" />);
      }
    }
  }

  return <tr>{elements}</tr>;
};

RadioButtonGroupRow.propTypes = {
  columns: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,
  questionNumber: PropTypes.number,
  questionId: PropTypes.string.isRequired,
  questionInput: PropTypes.object,
  questionDesc: PropTypes.string,
  style: PropTypes.object,
  validate: PropTypes.array,
};

export const MoreInfoGroupRow = props => {
  const style = { ...props.style };

  const elements = [];

  let name = `MoreInfoSubQNo${props.number}`;
  elements.push(
    <td style={style} key={`more-info-sub-q-no-${props.number}`}>
      <input type="text" name={name} id={name} />
    </td>
  );

  name = `MoreInfoName${props.number}`;
  elements.push(
    <td style={style} key={`more-info-name-${props.number}`}>
      <input type="text" name={name} id={name} />
    </td>
  );

  name = `MoreInfoDiagnosis${props.number}`;
  elements.push(
    <td style={style} key={`more-info-diagnosis-${props.number}`}>
      <input type="text" name={name} id={name} />
    </td>
  );

  return <tr>{elements}</tr>;
};

MoreInfoGroupRow.propTypes = {
  number: PropTypes.number.isRequired,
  style: PropTypes.object,
};

export const YesNo = ({ name, validate, labels, reverse }) => {
  const yes = (
    <label title="Yes">
      <Field
        showOuterDiv={false}
        name={name}
        type="radio"
        value="Yes"
        component={renderField}
        validate={validate}
      >
        <img alt="" />
        {labels.yes}
      </Field>
    </label>
  );
  const no = (
    <label title="No">
      <Field
        showOuterDiv={false}
        name={name}
        type="radio"
        value="No"
        component={renderField}
        validate={validate}
      >
        <img alt="" />
        {labels.no}
      </Field>
    </label>
  );

  return (
    <div className="custom-checkbox checks-group">
      {reverse && no}
      {yes}
      {!reverse && no}
    </div>
  );
};

YesNo.defaultProps = {
  labels: {
    yes: "Yes",
    no: "No",
  },
  reverse: false,
};

YesNo.propTypes = {
  name: PropTypes.string.isRequired,
  labels: PropTypes.shape({}),
  validate: PropTypes.array,
  reverse: PropTypes.bool,
};

export const YesNoChecks = ({ name, questionDesc, style, validate, isQuestionRaw }) => {
  return (
    <div className="row" style={style}>
      {isQuestionRaw && (
        <div style={{ maxWidth: 740 }} dangerouslySetInnerHTML={{ __html: questionDesc }} />
      )}
      {!isQuestionRaw && <div style={{ maxWidth: 740 }}>{questionDesc}</div>}
      <YesNo name={name} validate={validate} />
    </div>
  );
};

YesNoChecks.defaultProps = {
  YesNoChecks: true,
};

YesNoChecks.propTypes = {
  name: PropTypes.string.isRequired,
  questionDesc: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  style: PropTypes.object,
  validate: PropTypes.array,
  isQuestionRaw: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Prudential/components.js